import { Injectable } from "@angular/core";
import { IBoxTypeEnum, IFieldTypeEnum } from "../../default-constants/document-type-settings.constants";
import { IBox, IField } from "../../document-type-settings.dto";
import { IMetadataItemDto, MetaDataTypeEnum } from "app/main/pages/settings/documentfields/metadata-item.dto";
import { FieldSection } from "../../../utils/document-type.utils";

@Injectable({
    providedIn: 'root'
})


export class CustomBoxBuilderService {

    constructor() { }



    /**
     * Constructs a new `IBox` object based on the provided `box` parameter,
     * applying default values for missing or undefined properties.
     *
     * @param box - The source `IBox` object to build from.
     * @returns A new `IBox` object with ensured default values:
     * - `id`: set to `box.id` or `null` if not provided.
     * - `name`: copied from `box.name`.
     * - `order`: set to `box.order` or `0` if not provided.
     * - `is_removeable`: set to `box.is_removeable` or `false` if not provided.
     * - `is_locked`: set to `box.is_locked` or `true` if not provided.
     * - `status`: set to `box.status` or `true` if not provided.
     */
    buildBox(box: IBox): IBox {
        return {
            id: box.id || null,
            name: box.name,
            order: box.order || 0,
            type: IBoxTypeEnum.CUSTOM,
            is_removeable: box.is_removeable || false,
            is_locked: box.is_locked || true,
            status: box.status || true
        }
    }




     /**
     * Builds a custom field object based on the currently selected metadata.
     *
     * @returns {IField} The constructed custom field object with properties populated from the selected metadata and active tab order.
     */
    buildCustomField(field: IMetadataItemDto, type?: FieldSection | MetaDataTypeEnum | IFieldTypeEnum): IField {
        return {
            id: null,
            meta_data_id: field.id,
            label: field.meta_data_name,
            field_name: field.api_attribute,
            order: 0,
            type: type ?? field.meta_data_type,
            status: true,
            is_locked: false,
        }
    }
}
